<div class="dialog-wrap">

    <h2 mat-dialog-title>Export Threshold Exceeded</h2>

    <mat-dialog-content>
        <p>
            <span [innerText]="dialogData | number"></span> set exceeds the max record threshold of 1,048,576 rows,
            which is the limit for exporting data in this application. Please filter the data set further to reduce
            the number of output rows.
        </p>
    </mat-dialog-content>

    <mat-dialog-actions>
        <span style="flex-grow:1"></span>
        <button mat-dialog-close tdoe-button variant="primary">Close</button>
    </mat-dialog-actions>

</div>